"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _inputSizes = _interopRequireDefault(require("../input/input-sizes.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const InputIconToggleStyle = _styledComponents.default.span.attrs(({
  onClick
}) => ({
  // eslint-disable-next-line consistent-return
  onKeyDown: e => {
    if (onClick && (e.key === " " || e.key === "Enter")) {
      e.preventDefault();
      return onClick(e);
    }
  },
  theme: _base.default
}))`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;

  ${({
  size
}) => (0, _styledComponents.css)`
    margin-right: -${_inputSizes.default[size].horizontalPadding};
    margin-left: -${_inputSizes.default[size].horizontalPadding};
    width: ${_inputSizes.default[size].height};
  `}

  &:focus {
    outline: solid 3px ${({
  theme
}) => theme.colors.focus};
  }
`;
InputIconToggleStyle.safeProps = ["size", "error", "warning", "info"];
InputIconToggleStyle.defaultProps = {
  size: "medium",
  theme: _base.default
};
InputIconToggleStyle.propTypes = {
  size: _propTypes.default.oneOf(["small", "medium", "large"]),
  error: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  warning: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  info: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool])
};
var _default = InputIconToggleStyle;
exports.default = _default;